export default __webpack_public_path__ + "static/signup-cover-8b7c1a9bea27300c6b632304da458ad3.jpg";